/* ==========================================================================
   Referral capture
   --------------------------------------------------------------------------
   Attribution has two independent carriers, because either one alone can be
   lost:

     1. The `sp_ref` cookie the marketing site sets on ".schedpilot.com".
        The API reads it server-side at registration. Invisible to this code
        (it is HttpOnly) and can be blocked by strict privacy settings.

     2. The `?ref=` query parameter the marketing site stamps onto links
        pointing at this app. That is what this module captures and keeps,
        so the code still survives if the visitor browses around before
        signing up.

   Whichever arrives, the registration call forwards what it has and the API
   falls back to the cookie when the body is empty.
   ========================================================================== */

const KEY      = 'sp_ref';
const TTL_DAYS = 60;

export function storeRef(ref) {
  if (!ref) return;
  const clean = String(ref).trim().slice(0, 64);
  if (!clean) return;

  try {
    localStorage.setItem(KEY, JSON.stringify({
      ref: clean,
      exp: Date.now() + TTL_DAYS * 24 * 60 * 60 * 1000,
    }));
  } catch (e) {
    // Private mode / storage disabled — the cookie is still in play.
  }
}

/** Returns the stored referral code, or '' once the 60-day window lapses. */
export function getStoredRef() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return '';

    const parsed = JSON.parse(raw);
    if (!parsed || !parsed.ref) return '';

    if (parsed.exp && Date.now() > parsed.exp) {
      localStorage.removeItem(KEY);
      return '';
    }
    return parsed.ref;
  } catch (e) {
    return '';
  }
}

export function clearRef() {
  try { localStorage.removeItem(KEY); } catch (e) {}
}

/** Reads ?ref= off the current URL and remembers it. Safe to call on load. */
export function captureRefFromUrl() {
  try {
    const ref = new URLSearchParams(window.location.search).get('ref');
    if (ref) storeRef(ref);
  } catch (e) {}
}
